import { QuoteToolPreselectedModes } from '@lx/shared/utils/enums';
import { z } from 'zod';

/**
 * Schema for representing the parameters of the Junior Camp deep link.
 * It is a Zod object schema where we define the required and optional parameters.
 * It is used to validate the parameters of the Junior Camp deep link.
 */
export const JuniorCampDeepLinkParameterSchema = z
  .object({
    preselectedMode: z.nativeEnum(QuoteToolPreselectedModes),
    schoolCode: z.string(),
    languageCode: z.string(),
    packageCode: z.string(),
    duration: z.number().min(1),
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    deeplinkType: z.string(),
  })
  .partial()
  .required({
    preselectedMode: true,
    schoolCode: true,
    packageCode: true,
  });
